import { memo } from 'react';

import { Tooltip } from '@mui/joy';

import useIsTruncated from '@/shared/hooks/useIsTruncated';

type Props = {
  value?: string | null | number;
};

const TruncatedCell: React.FC<Props> = ({ value }) => {
  const { ref: containerRef, isTruncated } = useIsTruncated<HTMLDivElement>();
  const display = value == null || (typeof value === 'string' && value.trim() === '') ? '-' : value;

  return (
    <Tooltip placement="top" title={isTruncated ? display : undefined}>
      <div ref={containerRef} className="truncate">
        {display}
      </div>
    </Tooltip>
  );
};

export default memo(TruncatedCell);
